export default "__VITE_ASSET__NmumaG6___"